
  $(document).ready(function () {
    let index = 0;
    let indexRecommendedSwiperInterval = setInterval(() => {
      index = index === 3 ? 0 : index + 1;
      indexRecommendedSwiperFuc(index);
    }, 3000);

    $(".index-recommended-swiper").hover(
      function () {
        clearInterval(indexRecommendedSwiperInterval);

        $(this)
          .find(".active-left,.active-right")
          .addClass("animate__fadeIn")
          .removeClass("animate__fadeOut");
      },
      function () {
        indexRecommendedSwiperInterval = setInterval(() => {
          index = index === 3 ? 0 : index + 1;
          indexRecommendedSwiperFuc(index);
        }, 3000);
        $(this)
          .find(".active-left,.active-right")
          .addClass("animate__fadeOut")
          .removeClass("animate__fadeIn");
      }
    );

    $(
      ".index-recommended-swiper>div>img,.index-recommended-swiper-point>span"
    ).click(function () {
      index = $(this).index();
      indexRecommendedSwiperFuc(index);
    });

    $(".index-recommended-swiper .active-left,.active-right").click(
      function () {
        index = index + +$(this).attr("data-active");
        if (index > 3) index = 0;
        if (index < 0) index = 3;
        indexRecommendedSwiperFuc(index);
      }
    );

    function indexRecommendedSwiperFuc(index) {
      $(".index-recommended-swiper")
        .children("div")
        .eq(0)
        .children("img")
        .eq(index)
        .addClass("index-recommended-active")
        .siblings()
        .removeClass("index-recommended-active");

      $(".index-recommended-swiper")
        .children("div")
        .eq(1)
        .children("ul")
        .children("li")
        .eq(index)
        .addClass("index-recommended-active animate__animated animate__fadeIn")
        .siblings()
        .removeClass("index-recommended-active");

      $(".index-recommended-swiper-point")
        .children("span")
        .eq(index)
        .addClass("index-recommended-swiper-point-active")
        .siblings()
        .removeClass("index-recommended-swiper-point-active");
    }


    $(".index-shop-slick").slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      speed: 300,
      autoplay: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
      ],
      prevArrow: `<div
            class="active-left"
          >
            <img src="https://cdn.shopifycdn.net/s/files/1/0746/6749/1629/files/7_1_4f59a463-2fa6-4f36-9416-d7953b0fb98b.png?v=1681097317" />
          </div>`,
      nextArrow: `<div
            class="active-right"
          >
            <img src="https://cdn.shopifycdn.net/s/files/1/0746/6749/1629/files/7_f223c28d-2ae4-49df-baec-9db3026acf95.png?v=1681097343" />
          </div>`,
    });

    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    const tooltipList = [...tooltipTriggerList].map(
      (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
    );

    $(".index-shop-item").hover(
      function () {
        $(this)
          .find(".index-shop-item-tool-pc")
          .addClass("animate__fadeInUp")
          .removeClass("animate__fadeOutDown");
      },
      function () {
        $(this)
          .find(".index-shop-item-tool-pc")
          .removeClass("animate__fadeInUp")
          .addClass("animate__fadeOutDown");
      }
    );
    let increaseLock = true;
    window.addEventListener(
      "scroll",
      throttle(() => {
        let scrollTop =
          document.body.scrollTop || document.documentElement.scrollTop;

        if (
          increaseLock &&
          Math.abs(
            scrollTop - $(".index-go").offset().top + $(window).height()
          ) < 100
        ) {
          increaseLock = false;
          $(".animateNum").each(function () {
            $(this).data("countToOptions", {
              formatter: function (b, a) {
                return b.toFixed(0).replace(/\B(?=(?:\d{3})+(?!\d))/g, ",");
              },
            });
            $(this).each(count);
          });
          setTimeout(() => {
            increaseLock = true;
          }, 1000);
        }
      }, 300),
      false
    );

    function throttle(fn, delay) {
      let timer;
      return function () {
        if (!timer) {
          timer = setTimeout(() => {
            fn();
            clearTimeout(timer);
            timer = null;
          }, delay);
        }
      };
    }

    $.fn.countTo = function (a) {
      a = a || {};
      return $(this).each(function () {
        var c = $.extend(
          {},
          $.fn.countTo.defaults,
          {
            from: $(this).data("from"),
            to: $(this).data("to"),
            speed: $(this).data("speed"),
            refreshInterval: $(this).data("refresh-interval"),
            decimals: $(this).data("decimals"),
          },
          a
        );
        var h = Math.ceil(c.speed / c.refreshInterval),
          i = (c.to - c.from) / h;
        var j = this,
          f = $(this),
          e = 0,
          g = c.from,
          d = f.data("countTo") || {};
        f.data("countTo", d);
        if (d.interval) {
          clearInterval(d.interval);
        }
        d.interval = setInterval(k, c.refreshInterval);
        b(g);

        function k() {
          g += i;
          e++;
          b(g);
          if (typeof c.onUpdate == "function") {
            c.onUpdate.call(j, g);
          }
          if (e >= h) {
            f.removeData("countTo");
            clearInterval(d.interval);
            g = c.to;
            if (typeof c.onComplete == "function") {
              c.onComplete.call(j, g);
            }
          }
        }

        function b(m) {
          var l = c.formatter.call(j, m, c);
          f.html(l);
        }
      });
    };
    $.fn.countTo.defaults = {
      from: 0,
      to: 0,
      speed: 1000,
      refreshInterval: 100,
      decimals: 0,
      formatter: formatter,
      onUpdate: null,
      onComplete: null,
    };

    function formatter(b, a) {
      return b.toFixed(0);
    }

    function count(a) {
      var b = $(this);
      a = $.extend({}, a || {}, b.data("countToOptions") || {});
      b.countTo(a);
    }

     /* 2022-12-7 add */


    $("#cartModal").on("show.bs.modal", (event) => {
      $(".cart-info").html(`     <div class="spinner-border text-secondary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>`)
       const id = $(event.relatedTarget).data("product-id");
      $(".cart-info").load(
        "https://www.magicyclebike.ca/pages/product_view/" +
          id +
          "?t=" +
          new Date().getTime()
      );
      // $(".cart-slick").slick({
      //   slidesToShow: 1,
      //   slidesToScroll: 1,
      //   speed: 300,
      //   prevArrow: `<div
      //       class="active-left"
      //     >
      //       <i class="bi bi-chevron-left"></i>
      //     </div>`,
      //   nextArrow: `<div
      //       class="active-right"
      //     >
      //       <i class="bi bi-chevron-right"></i>
      //     </div>`,
      // });
    });

    // $("#cart-info-right-addCart").click(function () {
    //   let data = {};
    //   let value = $("#cart-info-form").serializeArray();
    //   $.each(value, function (index, item) {
    //     data[item.name] = item.value;
    //   });
    //   //属性数据
    //   console.log(data);
    //   $.ajax({
    //     url: "",
    //     data: data,
    //     success: function (result) {},
    //   });
    //   // 启动购物车
    //   const bsOffcanvas = new bootstrap.Offcanvas("#h5-cart");
    //   bsOffcanvas.show();
    // });

    /* 2022-12-7 end */
  });
